angular.module('newsandtrendsTagPage.service', [])
.factory('kit', [function () {
    var exports = {
        getParams: function () {
            var ret = {};
            var str = location.search;
            if (str) {
                str = str.slice(1);
                angular.forEach(str.split('&'), function (tmp) {
                    var _arr = tmp.split('=');
                    ret[_arr[0]] = _arr[1];
                });
            }
            return ret;
        }
    };
    return exports;
}])
;